/*
 * Withdrawal ("Vertrag widerrufen") form.
 *
 * Posts the declaration to the configured endpoint as JSON and swaps the form
 * for an on-screen confirmation. The withdrawal is legally effective the moment
 * the customer declares it, so the endpoint is expected to record the request
 * first and send the confirmation email second; a mail failure must not surface
 * here as a failed submission.
 *
 * Without JavaScript the form falls back to a normal POST to the same endpoint.
 */
(function () {
  var SUBMIT_TIMEOUT = 20000;

  function serialize(form) {
    var data = {};
    var elements = form.elements;

    for (var i = 0; i < elements.length; i++) {
      var field = elements[i];
      if (!field.name || field.disabled || field.type === 'submit') continue;

      if (field.type === 'checkbox') {
        data[field.name] = field.checked;
      } else {
        data[field.name] = field.value.trim();
      }
    }

    return data;
  }

  function formatTimestamp(value) {
    var date = value ? new Date(value) : new Date();
    if (isNaN(date.getTime())) date = new Date();

    try {
      return date.toLocaleString(document.documentElement.lang || undefined, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch (error) {
      return date.toISOString();
    }
  }

  function showError(form, message) {
    var box = form.querySelector('[data-withdrawal-error]');
    if (!box) return;

    var text = box.querySelector('[data-withdrawal-error-text]');
    if (text && message) text.textContent = message;

    box.hidden = false;
    box.focus();
  }

  function hideError(form) {
    var box = form.querySelector('[data-withdrawal-error]');
    if (box) box.hidden = true;
  }

  function showSuccess(form, receivedAt) {
    var panel = document.querySelector('[data-withdrawal-success]');
    if (!panel) return;

    var stamp = panel.querySelector('[data-withdrawal-timestamp]');
    if (stamp) {
      var prefix = form.getAttribute('data-timestamp-prefix') || '';
      stamp.textContent = (prefix + ' ' + formatTimestamp(receivedAt)).trim();
    }

    form.hidden = true;
    panel.hidden = false;
    panel.focus();
    panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function setBusy(form, busy) {
    var button = form.querySelector('[data-withdrawal-submit]');
    if (!button) return;

    if (busy) {
      button.dataset.idleLabel = button.textContent.trim();
      var loading = form.getAttribute('data-loading-label');
      if (loading) button.textContent = loading;
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-busy', 'true');
    } else {
      if (button.dataset.idleLabel) button.textContent = button.dataset.idleLabel;
      button.removeAttribute('disabled');
      button.removeAttribute('aria-busy');
    }
  }

  function send(endpoint, payload) {
    // AbortController keeps a hung endpoint from leaving the button disabled
    // forever, which would read to the customer as a lost declaration.
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller
      ? setTimeout(function () {
          controller.abort();
        }, SUBMIT_TIMEOUT)
      : null;

    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
      signal: controller ? controller.signal : undefined,
    }).then(function (response) {
      if (timer) clearTimeout(timer);

      return response
        .json()
        .catch(function () {
          return {};
        })
        .then(function (body) {
          // A non-JSON 2xx still counts as accepted; only an explicit
          // `ok: false` or a failing status is treated as a rejection.
          if (!response.ok || body.ok === false) {
            var error = new Error(body.error || 'Request failed');
            error.handled = true;
            throw error;
          }
          return body;
        });
    });
  }

  function onSubmit(event) {
    var form = event.currentTarget;
    var endpoint = form.getAttribute('data-endpoint');

    if (!endpoint || typeof fetch !== 'function') return; // native POST fallback

    event.preventDefault();

    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      if (typeof form.reportValidity === 'function') form.reportValidity();
      return;
    }

    if (form.dataset.submitting === 'true') return;

    var data = serialize(form);

    // Honeypot: silently accept without contacting the endpoint.
    if (data.company) {
      showSuccess(form);
      return;
    }
    delete data.company;

    data.submitted_at = new Date().toISOString();
    data.locale = document.documentElement.lang || '';
    data.page_url = window.location.href;
    if (window.Shopify && window.Shopify.shop) data.shop = window.Shopify.shop;

    hideError(form);
    form.dataset.submitting = 'true';
    setBusy(form, true);

    send(endpoint, data)
      .then(function (body) {
        showSuccess(form, body.received_at);
      })
      .catch(function (error) {
        showError(form, form.getAttribute('data-error-message'));
        if (window.console && console.warn) {
          console.warn('[withdrawal-form] submission failed:', error.message);
        }
      })
      .then(function () {
        form.dataset.submitting = 'false';
        setBusy(form, false);
      });
  }

  function init() {
    var forms = document.querySelectorAll('[data-withdrawal-form]');

    for (var i = 0; i < forms.length; i++) {
      if (forms[i].dataset.withdrawalReady === 'true') continue;
      forms[i].dataset.withdrawalReady = 'true';
      forms[i].addEventListener('submit', onSubmit);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor re-renders sections without a full page load.
  document.addEventListener('shopify:section:load', init);
})();
